import { createSelector } from "reselect";
import { isEmpty, isNumber } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => {
  try {
    const profile = state.user.profile;
    if (isEmpty(profile)) {
      return 0;
    }

    if (isNumber(+profile.profileComplete)) {
      return profile.profileComplete;
    } else {
      return 0;
    }
  } catch (error) {
    return 0;
  }
};
//VERIFY IF THE JWT IS SET
const getMyProfileCompletePercent = createSelector(
  getData,
  profileComplete => profileComplete
);
export default getMyProfileCompletePercent;



// WEBPACK FOOTER //
// ./src/_selectors/userSelectors/getMyProfileCompletePercent.js